export default {
  CANONICAL_ID_ATTR: 'data-ws-canonical-id',
  STATUS_PENDING: 'PENDING',
  STATUS_UNDO: 'UNDOING',
  STATUS_REDO: 'REDOING',
};
